/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Address_PlaceholderInputs */

const en_clients_field_address_placeholder = /** @type {(inputs: Clients_Field_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street, number, district, city/state`)
};

const pt_br2_clients_field_address_placeholder = /** @type {(inputs: Clients_Field_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rua, número, bairro, cidade/UF`)
};

/**
* | output |
* | --- |
* | "Street, number, district, city/state" |
*
* @param {Clients_Field_Address_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_address_placeholder = /** @type {((inputs?: Clients_Field_Address_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Address_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_address_placeholder(inputs)
	return pt_br2_clients_field_address_placeholder(inputs)
});